var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading text--xl"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('common.loadingContent'))}}),_c('v-progress-circular',{attrs:{"size":40,"width":3,"color":"primary","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }